import { PageHeading } from "@/components/common/PageHeading.tsx";
import { CreateAppointmentDto, PatchAppointmentDto } from "@/models";
import { useStore } from "@/stores/useStore.ts";
import { LoadingPage } from "@/components/page/LoadingPage.tsx";
import { Link, useNavigate } from "react-router-dom";
import { useToast } from "@/hooks/useToast.tsx";
import { Button } from "@/components/base/Button.tsx";
import { ArrowLeftIcon } from "lucide-react";
import { appointment } from "@/repositories/appointment.ts";
import { CreateEditAppointmentForm } from "@/components/forms/CreateEditAppointment.form.tsx";

export const CreateAppointmentPage = () => {
  const tenant = useStore((s) => s.tenant);
  const navigate = useNavigate();
  const { toast } = useToast();

  if (!tenant) {
    return <LoadingPage />;
  }

  const handleOnSubmit = async (
    values: CreateAppointmentDto | PatchAppointmentDto
  ) => {
    if ((values as PatchAppointmentDto).id) {
      return;
    }
    await appointment
      .create(values as CreateAppointmentDto, tenant.id)
      .then(() => {
        toast({
          title: "Appointment Created!",
          description: `Appointment created successfully.`,
        });
        navigate("..");
      });
    return;
  };

  const handleCancel = async () => {
    navigate("..");
  };

  return (
    <div className="p-4 w-full">
      <div className="flex flex-row space-between pb-4">
        <PageHeading>Create Appointment</PageHeading>
        <div className="flex flex-grow" />
        <Link to="..">
          <Button>
            <ArrowLeftIcon /> Back to Appointments
          </Button>
        </Link>
      </div>
      <CreateEditAppointmentForm
        onSubmit={handleOnSubmit}
        tenantId={tenant.id}
        onCancel={handleCancel}
        isEditable
      />
    </div>
  );
};
